import React, { useState } from 'react';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Imagem from 'Component/Imagem';
import Questao from 'Interface/Questoes';
import { useRemoverQuestaoMutation } from 'Service';

import Editar from './Editar';

interface Props {
    dados: Questao;
    acoes?: boolean;
}

const Lista = ({ dados }: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ modal, setModal ] = useState<boolean>(false);
    const [ removerQuestao ] = useRemoverQuestaoMutation();

    const remover = async (): Promise<void> =>
    {
        try {
            await removerQuestao(dados).unwrap();

            toast({
                conteudo: 'Removido com sucesso!',
                tema: 'success',
            });
        } catch (erro) {
            toast({
                titulo: 'Erro ao remover',
                conteudo: 'Verifique o registro de log para mais detalhes!',
                tema: 'danger',
            });
        }
    }

    return (
        <React.Fragment>
            <div className="border-top py-2 px-3 fs-5 d-flex align-items-center">
                <div className="cursor-pointer" onClick={ () => setModal(true) }>
                    <p>
                        { dados.enunciado }
                    </p>
                </div>
                <div className="ms-auto">
                    <Botao
                        icone="trash"
                        tema="danger"
                        className="ms-5 align-self-end"
                        confirmacao="Você tem certeza que deseja remover essa questão? Essa ação é irreversivel."
                        onClick={ remover }
                    />
                </div>
            </div>
            { dados.imagem && (
                <div className="d-flex justify-content-center">
                    <Imagem
                        src={ dados.imagem }
                        className="img-fluid mx-3 mb-3 col-md-6 rounded-3 shadow-lg"
                    />
                </div>
            ) }
            <div className="px-3">
                <strong>Alternativas:</strong>
                <ol className="fs-5">
                    { dados.alternativas?.map(alternativa => (
                        <li
                            key={ `${alternativa.id}-${alternativa.modificado}` }
                            className={ alternativa.correta ? 'text-success fw-bold' : '' }
                        >
                            { alternativa.texto }
                        </li>
                    )) }
                </ol>
            </div>
            <Editar
                id={ dados.id }
                exibir={ modal }
                aoFechar={ setModal }
            />
        </React.Fragment>
    )
}

export default Lista;
